import React from "react";
import styles from "./InfoBar.module.css";

export default function InfoBar({ message, severity, onClose }) {
	return (
		message &&
		severity &&
		onClose && (
			<div className={`${styles.infoBar} ${styles[severity]}`}>
				{message}
				<div className={styles.close} onClick={onClose}>
					x
				</div>
			</div>
		)
	);
}
